import React from 'react';
import { Percent, MonitorSmartphone, MessageCircle, ShieldCheck, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const valueProps = [{
  icon: Percent,
  title: 'Tarifas competitivas desde 0%',
  description: 'Ofrecemos las mejores tarifas del mercado para negocios establecidos'
}, {
  icon: MonitorSmartphone,
  title: 'POS y terminales modernas',
  description: 'Equipos de última generación para tu negocio'
}, {
  icon: MessageCircle,
  title: 'Atención en español',
  description: 'Todo nuestro equipo habla español y entiende tu negocio'
}, {
  icon: ShieldCheck,
  title: 'Sin contratos largos',
  description: 'Flexibilidad total, sin ataduras ni compromisos extensos'
}, {
  icon: MapPin,
  title: 'Integración y soporte local',
  description: 'Servicio personalizado y soporte técnico cuando lo necesites'
}];
export function ValuePropsSection() {
  return <section id="servicios" className="bg-lightGray py-16 md:py-24" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-123">
          {valueProps.map((prop, index) => {
          const Icon = prop.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow" data-id="element-124">
                <div className="w-12 h-12 bg-gold bg-opacity-10 rounded-lg flex items-center justify-center mb-4" data-id="element-125">
                  <Icon className="text-gold" size={24} data-id="element-126" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-navy" data-id="element-127">
                  {prop.title}
                </h3>
                <p className="text-gray-600" data-id="element-128">{prop.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}